import {Component} from '@angular/core';
import {ImageSliderComponent} from '../image-slider/image-slider.component';

@Component({
  selector: 'performancelevel-slider',
  templateUrl: 'performancelevel-slider.html',
  styleUrls: ['performancelevel-slider.scss'],
})
export class PerformancelevelSliderComponent extends ImageSliderComponent { }
